// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2328":"admin","2334":"ProgressBar","2369":"carousel","4359":"Result","5887":"Steps","6471":"DragAndDrop"}[chunkId] + "." + {"2328":"41593e63","2334":"c00ea573","2369":"878b5d5d","4359":"c43c4c1a","5887":"915b0dd2","6471":"eff1d253"}[chunkId] + ".css";
};